<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="num_cotacao" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">N cotação</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="descr" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Descrição</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="status"
                        :options="optionsLivStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col md="4" sm="4" class="p-0 m-t-5px">
                       <multiselect v-model="pessoa_origem"
                       :options-limit="300"
                       :limit="2"
                       :limit-text="limitText"
                       :options="optionsPessoa"
                       track-by="value"
                       label="label"
                       id="cliente_ori"
                       :hide-selected="true"
                       placeholder="Cliente Origem( Digite 3 caracteres para pesquisar )"
                       tag-placeholder="Selecionar"
                       select-label="Selecionar"
                       selected-label="Selecionado"
                       deselect-label="Remover"
                       :searchable="true"
                       :loading="isLoadingPessoa"
                       @search-change="listaClientesPessoa"
                       ></multiselect>
                    </b-col>
                    <b-col md="4" sm="4" class="p-0 m-t-5px">
                       <multiselect v-model="pessoa_destino"
                       :options-limit="300"
                       :limit="2"
                       :limit-text="limitText"
                       :options="optionsPessoa"
                       track-by="value"
                       label="label"
                       id="cliente_ori"
                       :hide-selected="true"
                       placeholder="Cliente Destino( Digite 3 caracteres para pesquisar )"
                       tag-placeholder="Selecionar"
                       select-label="Selecionar"
                       selected-label="Selecionado"
                       deselect-label="Remover"
                       :searchable="true"
                       :loading="isLoadingPessoa"
                       @search-change="listaClientesPessoa"
                       ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                          <div class="btn-group">
                            <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                            <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                          </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
        helpForm: new Form({params: [], search: ''}),
        num_cotacao: '',
        descr: '',
        pessoa_origem: [],
        pessoa_destino: [],
        isLoadingPessoa: false,
        optionsPessoa: [],
        optionsLivStatus: [],
        status: [],
        data_filter: []
    }
  },
  mounted() {
      this.getStatus();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {num_cotacao: this.num_cotacao,
                              descr: this.descr,
                              pessoa_origem: this.pessoa_origem,
                              pessoa_destino: this.pessoa_destino,
                              status: this.status};
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
          this.num_cotacao = '';  // clear the text in text input
          this.descr = '';
          this.status = '';
          this.pessoa_destino = '';
          this.pessoa_origem = '';
        this.$events.fire('filter-reset');
      },
      listaClientesPessoa(search) {
          if(search.length>=3)
          {
              this.isLoadingPessoa = true;
              this.helpForm.search = search;
              this.helpForm.status = 1;
              this.helpForm.post('/api/pessoa/jsonlist').then(response =>
              {
                  this.optionsPessoa = [];
                  new ReturnApi(response, this, true, false, false);
                  if(response.items.length>0)
                  {
                      response.items.forEach((obj)=>
                      {
                          this.optionsPessoa.push({ label: "PJ -"+obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                      });
                  }
                  if(response.itemsF.length>0) {
                      response.itemsF.forEach((obj)=>
                      {
                          this.optionsPessoa.push({ label: "PF -"+obj.nome+" - "+obj.cpf, value: obj.pessoa_id })
                      });
                  }
                  if(response.itemsE.length>0)
                  {
                      response.itemsE.forEach((obj)=>
                      {
                          this.optionsPessoa.push({ label: "PE -"+obj.nome+" - "+obj.cd, value: obj.pessoa_id })
                      });
                  }
                  this.isLoadingPessoa = false;
              })
              .catch(errors =>
              {
                  new ReturnApi(errors, this)
                });
            }
        },
        limitText(count) {
            return ' e ${count} outros clientes'
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
        {
            var cnpj_formatado
            var pad = "00000000"
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;

            return cnpj_base+""+cnpj_filial+""+cnpj_digito;
        },
      getStatus() {
          this.helpForm.params = { tabela: 'cotacao',
                                  coluna: 'status' };

          this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
              });
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this, true, false, false)
          });
      }
  },
  computed: {
      vuetableFilterButton: {
          get () {
              return this.$store.state.vuetable.filterButton;
          },
      },
  }
}
</script>
